module.exports = __webpack_public_path__ + "img/0fc7b06.png";